import {
  EWayBillReviewDataType,
  EinvoiceReviewDataType,
  InvoiceGenerationCategoryType,
  InvoiceGenerationColumnsType,
  InvoiceGenerationTypes,
} from "./invoiceGenrationTypes";

export const initialState: InvoiceGenerationTypes = {
  fetching: false,
  pdfFetching: false,
  templateFetching: false,
  success: null,
  overDueEmailSuccess: null,
  error: null,
  statusCode: null,
  message: null,
  uniqueTemplateNameMessage: null,
  overDueEmailMessage: null,
  allColumnsList: {} as InvoiceGenerationColumnsType,
  mappedExpensesColumnsList: {} as InvoiceGenerationCategoryType,
  mappedRevenueColumnsList: {} as InvoiceGenerationCategoryType,
  mappedOthersColumnList: {} as InvoiceGenerationCategoryType,
  allOtherInvoicesList: [],
  allExpensesInvoicesList: [],
  allRevenueInvoicesList: [],
  otherInvoicesTotal: "",
  expensesInvoicesTotal: "",
  revenueInvoicesTotal: "",
  singleInvoiceDetails: {},
  singleOtherInvoiceDetails: {},
  bulkUploadData: {},
  isDuplicateEntry: null,
  allComments: [],
  commentsSuccess: null,
  approvalSuccess: null,
  paymentPendingList: [],
  allAllocationList: [],
  lockOthersEntriesDate: null,
  lockRevenueEntriesDate: null,
  lockExpensesEntriesDate: null,
  eInvoiceData: {},
  eInvoiceError: [],
  eWayBillError: "",
  eWayBillUpdateError: "",
  eInvoiceReviewData: {} as EinvoiceReviewDataType,
  eWayBillReviewData: {} as EWayBillReviewDataType,
  invoiceNotesList: [],
  customerSingleInvoiceData: {},
  bomListData: { total_count: "", data: [] },
  bomSavedTemplateListData: { total_count: "", data: [] },
  singleBomData: [],
  singleBomTemplateData: {},
  invoiceHistoryData: [],
  invoiceHistoryCount: 0,
  othersHistoryData: [],
  othersHistoryCount: 0,
  bulkUploadHistoryData: [],
  bulkUploadCount: "",
  bulkUploadFetching: false,
  pinCodeDistanceCountData: {},
  pinCodeFetching: false,
  pinCodeError: "",
  lockBOMEntriesDate: null,
  isClientColumnAssignedSuccess:null,
  isClientColumnAssignedMessage:null,
  
};
